import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  Building2,
  User,
  DollarSign,
  Calendar,
  AlertCircle,
  Zap,
  Receipt,
  Pencil,
  Eye,
} from "lucide-react";
import { format } from "date-fns";
// import EditDealModal from "../../pages/deals/deal/add-edit-modal/EditDealModal";
import NewEyeIcon from "../icons/action-eye-icon";
import NewCardIcon from "../icons/action-card-icon";
import { CustomDropdown } from "../ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../ui/dropdown/CustomDropdownButton";
import DotsVerticalIcon from "../icons/dots-vertical";
import { CustomDropdownMenu } from "../ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../ui/dropdown/CustomDropdownMenuList";
import NewEditIcon from "../icons/action-edit-icon";
import { Link } from "react-router";
import EmployeeDirectoryAddUpdate from "../../pages/organization/emplyee-directory/add-update";

// 🔹 Custom Badge component
const Badge = ({ children, className = "" }) => {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-md border text-xs font-medium ${className}`}
    >
      {children}
    </span>
  );
};

const priorityConfig = {
  Critical: {
    color: "bg-red-100 text-red-700 border-red-200",
    icon: AlertCircle,
  },
  High: { color: "bg-orange-100 text-orange-700 border-orange-200", icon: Zap },
  Medium: { color: "bg-blue-100 text-blue-700 border-blue-200", icon: null },
  Low: { color: "bg-slate-100 text-slate-600 border-slate-200", icon: null },
};

export default function DealCard({
  deal,
  onClick,
  isDragging,
  accentHexColor,
  colors,
  PackageList = [],
  ProductList = [],
  ClientList = [],
  DealStages = [],
  UserList = [],
  contactId = {},
  onDealUpdated = () => {}, // refresh after update
  onSubmit = () => {},
  onError2 = () => {},
  onLoadMoreClients = {},
  hasMoreClients = {},
  page = {},
  isLoadingClients = {},
}) {
  const priority = priorityConfig[deal.priority] || priorityConfig["Medium"];
  const PriorityIcon = priority.icon;

  const [edit, setEdit] = useState(false);

  const editDeal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setEdit(true);
    console.log("complete deal", deal?.completeDeal);
    console.log("deal" ,deal);
    
  };

  const [Menu,showMenu] = useState(false);



  return (
    <>
      <motion.div
        whileHover={{ scale: 1.01, y: 0 }}
        whileTap={{ scale: 0.99 }}
        // onClick={() => onClick(deal)}
        className={`flex p-4 rounded-lg border border-[#E1E4EA] bg-[#fff] transition-all duration-300   ${
          isDragging ? "shadow-md" : "hover:shadow-md"
        }`}
        style={{
          borderLeftColor: accentHexColor,
          boxShadow: isDragging
            ? `0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04), 0 0 0 1px ${accentHexColor}`
            : "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
        }}
      >
        <div className="space-y-4 w-full -z-0">
          {/* Header */}
          {/* <div className="flex items-start justify-between">
          <div className="flex-1 min-w-0">
            <h4 className="font-bold text-slate-900 text-base leading-tight truncate">
              {deal.contact_name}
            </h4>
            <p className="text-xs text-slate-500 truncate">
              {deal.deal_package}
            </p>
          </div>
          {deal.priority && deal.priority !== "Medium" && (
            <Badge
              className={`${priority.color} border text-xs font-semibold shadow-sm`}
            >
              {PriorityIcon && <PriorityIcon className="w-3 h-3 mr-1" />}
              {deal.priority}
            </Badge>
          )}
        </div> */}

          {/* Header */}
          <div className="flex items-start justify-between">
            <div className="flex-1 min-w-0">
              <h4
                className={`font-bold text-slate-900 text-sm leading-tight truncate border-l-2  border-l-[${
                  colors?.color ? colors?.color : "#9D5FEF"
                }] p-2`}
                style={
                  colors?.color
                    ? { borderColor: colors?.color }
                    : { borderColor: "#9D5FEF" }
                }
              >
                {deal?.contact_name}
                <p className="text-xs text-slate-500 truncate">
                  {deal?.deal_package || "-"}
                </p>
              </h4>
            </div>
            <div className="flex gap-1  p-2 z-50">
            
              
              <div className="">

                <div className="-mr-4 transition-all duration-300 hover:text-gray-500 relative cursor-pointer" onClick={() => {showMenu(!Menu)}}   >
                     <DotsVerticalIcon />

                     {
                    Menu ?

                    <div className={`border border-white shadow-xl absolute right-0 flex cursor-pointer  ${Menu ? "opacity-1" : "opacity-0"}`}>
                   
                   {
                    deal?.current_stage == "Won" || deal?.current_stage == "Lost" ?
                    null:
                   
                    <div className="d-flex align-items-center gap-1">
                      <div
                        className={`w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300 
                                                      ${
                                                        deal?.current_stage
                                                           ===
                                                          "Won" ||
                                                        deal?.current_stage
                                                           ===
                                                          "Lost"
                                                          ? "opacity-50 cursor-not-allowed"
                                                          : ""
                                                      }`}
                        disabled={
                          deal?.current_stage === "Won" ||
                          deal?.current_stage === "Lost"
                        }
                       
                        onClick={ deal?.current_stage == "Won" || deal?.current_stage == "Lost" ?  null  : (e) => {editDeal(e)} }
                      >
                        <div
                          className="flex"
                          style={{ color: "#FF9500" }}
                          onClick={() => {showMenu(false)}}
                        >
                          <NewEditIcon className="h-4.5 w-4.5" />
                        </div>
                      </div>
                    </div>
}

                     <div className="d-flex align-items-center gap-1">
                      <div
                        className={
                          "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                        }
                          onClick={() => {onClick(deal)}}
                          
                      >
                        <div
                          className="flex"
                          style={{ color: "#007AFF" }}
                          onClick={() => {showMenu(false)}}
                        >
                          <NewEyeIcon className="h-4.5 w-4.5" />
                        </div>
                      </div>
                    </div>

                     <div className="d-flex align-items-center gap-1">
                      <Link
                        to={`/deals/dealDetail/${deal?.id}`}
                        className={
                          "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                        }
                      >
                        <div
                          className="flex"
                          style={{ color: "#34C759" }}
                          onClick={() => {showMenu(false)}}
                        >
                          <NewCardIcon className="h-4.5 w-4.5" />
                        </div>
                      </Link>
                    </div>

                 </div>
                  : null

                }

                </div>

                
                 


              </div>

             
            </div>
          </div>

          {/* Value */}
          {/* <div className="flex items-center justify-between">
          <div className="flex items-center gap-0">
            <DollarSign className="w-4 h-3 text-emerald-600" />
            <span className="font-semibold text-sm text-slate-800">
              {deal.deal_value
                ? `$${deal.deal_value.toLocaleString()}`
                : "No value"}
            </span>
          </div>

          
          <div className="space-y-2">
            {deal.contact_name && (
              <div className="flex items-center gap-0">
                <User className="w-4 h-4 text-slate-400" />
                <span className="text-sm text-slate-600 truncate max-w-20">
                  {deal.contact_name}
                </span>
              </div>
            )}
          </div>

          
        </div> */}

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1">
              {/* <DollarSign className="w-4 h-3 text-emerald-600" /> */}
              <Receipt color="#53d20f" className="w-4 h-4" />

              <span className="font-semibold text-sm text-slate-800">
                {deal.deal_value
                  ? `$${deal.deal_value.toLocaleString()}`
                  : "No value"}
              </span>
            </div>

            {deal?.contact_name && (
              <div className="flex items-center gap-1">
                <User size={16} color="#a09c9c" strokeWidth={2.5} />
                <span className="text-sm text-slate-600 truncate max-w-20">
                  {deal?.contact_name ?? "-"}
                </span>
              </div>
            )}
          </div>

          {/* Footer */}
          {/* <div className="flex items-center justify-between pt-2 border-t border-slate-100">
          {deal.deal_date && (
            <div className="flex items-center gap-1">
              <Calendar className="w-3 h-3 text-slate-400" />
              <span className="text-xs text-slate-500 font-medium">
                {format(new Date(deal.deal_date), "MMM d")}
              </span>
            </div>
          )}

          <div className="flex items-center gap-1">
            <div className="w-6 h-6 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-sm">
              <span className="text-xs font-bold text-white">
                {deal?.assigned_to && deal.assigned_to.trim() !== ""
                  ? deal.assigned_to[0]?.toUpperCase()
                  : "N"}
              </span>
            </div>
            <span className="text-xs text-slate-500 font-medium truncate max-w-20">
              {deal?.assigned_to && deal.assigned_to.trim() !== ""
                ? deal.assigned_to
                : "Not Assigned"}
            </span>
          </div>
        </div> */}

          <div className="flex items-center justify-between pt-2 border-t border-slate-300 ">
            <div className="flex items-center gap-1">
              {/* <Calendar className="w-3 h-3 text-slate-400" /> */}
              <Calendar size={20} color="#a09c9c" strokeWidth={2.5} />
              <span className="text-xs  font-medium leading-9">
                {deal?.deal_date
                  ? format(new Date(deal?.deal_date), "MMM d")
                  : "-"}
              </span>
            </div>

            <div className="flex items-center gap-1 h-full">
              <div
                className={`w-6 h-6 bg-[${
                  colors?.color ? colors.color : "#9D5FEF"
                }] rounded-full flex items-center justify-center shadow-sm`}
                style={
                  colors?.color
                    ? { backgroundColor: colors?.color }
                    : { backgroundColor: "#9D5FEF" }
                }
              >
                <span className="text-xs font-bold text-white">
                  {deal?.assigned_to && deal?.assigned_to.trim() !== "" ? (
                    deal?.assigned_to[0]?.toUpperCase()
                  ) : (
                    <User size={16} color="white" strokeWidth={2.5} />
                  )}
                </span>
              </div>
              <span className="text-xs  font-medium truncate max-w-20 leading-9">
                {deal?.assigned_to && deal?.assigned_to.trim() !== ""
                  ? deal?.assigned_to
                  : "Not Assigned"}
              </span>
            </div>
          </div>
        </div>
      </motion.div>

      {edit && (
       // <EditDealModal
        //   open={edit}
        //   onClose={() => setEdit(false)}
        //   dealData={deal?.completeDeal}
        //   PackageList={PackageList}
        //   DealStages={DealStages}
        //   ProductList={ProductList}
        //   ClientList={ClientList}
        //   UserList={UserList}
        //   contactId={deal?.contactid}
        //   onDealUpdated={onDealUpdated} // refresh after update
        //   onSubmit={onSubmit}
        //   onError={onError2}


          
        // />

         <EmployeeDirectoryAddUpdate
                  open={edit}
                  onClose={() => {
                    setEdit(false)
                  }}
                  data={deal?.completeDeal}
                  tabIndex={1}
                  contactId={deal?.contactid}
                  onDealUpdated={onDealUpdated} 
                  onSubmit={onSubmit}
                  oonError={onError2}
                />
      )}
    </>
  );
}
